var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOkx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 791 266",
    style: {
      enableBackground: "new 0 0 791 266"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M242.7,23h-214c-1.3,0-2.6,0.5-3.5,1.5c-0.9,0.9-1.5,2.2-1.5,3.5v214c0,1.3,0.5,2.6,1.5,3.5c0.9,0.9,2.2,1.5,3.5,1.5h214 c1.3,0,2.6-0.5,3.5-1.5c0.9-0.9,1.5-2.2,1.5-3.5V28c0-1.3-0.5-2.6-1.5-3.5C245.3,23.5,244,23,242.7,23z M173,167.4 c0,1.3-0.5,2.6-1.5,3.5c-0.9,0.9-2.2,1.5-3.5,1.5h-64.7c-1.3,0-2.6-0.5-3.5-1.5c-0.9-0.9-1.5-2.2-1.5-3.5v-64.7 c0-1.3,0.5-2.6,1.5-3.5c0.9-0.9,2.2-1.5,3.5-1.5H168c1.3,0,2.6,0.5,3.5,1.5c0.9,0.9,1.5,2.2,1.5,3.5V167.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M690.8,97.7h-64.7c-2.7,0-5,2.2-5,5v64.7c0,2.7,2.2,5,5,5h64.7c2.7,0,5-2.2,5-5v-64.7C695.8,99.9,693.5,97.7,690.8,97.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M616.1,23h-64.7c-2.7,0-5,2.2-5,5v64.7c0,2.7,2.2,5,5,5h64.7c2.8,0,5-2.2,5-5V28C621.1,25.2,618.8,23,616.1,23z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M765.4,23h-64.7c-2.7,0-5,2.2-5,5v64.7c0,2.7,2.2,5,5,5h64.7c2.7,0,5-2.2,5-5V28C770.4,25.2,768.2,23,765.4,23z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M616.1,172.3h-64.7c-2.7,0-5,2.2-5,5V242c0,2.7,2.2,5,5,5h64.7c2.8,0,5-2.2,5-5v-64.7C621.1,174.6,618.8,172.3,616.1,172.3z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M765.4,172.3h-64.7c-2.7,0-5,2.2-5,5V242c0,2.7,2.2,5,5,5h64.7c2.7,0,5-2.2,5-5v-64.7C770.4,174.6,768.2,172.3,765.4,172.3z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M504,23h-64.7c-2.7,0-5,2.2-5,5v64.7c0,2.7,2.2,5,5,5H504c2.7,0,5-2.2,5-5V28C509,25.2,506.7,23,504,23z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M504,172.3h-64.7c-2.7,0-5,2.2-5,5V242c0,2.7,2.2,5,5,5H504c2.7,0,5-2.2,5-5v-64.7C509,174.6,506.7,172.3,504,172.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M434.3,102.6c0-1.3-0.5-2.6-1.5-3.5c-0.9-0.9-2.2-1.5-3.5-1.5h-69.7V28c0-1.3-0.5-2.6-1.5-3.5c-0.9-0.9-2.2-1.5-3.5-1.5H290 c-1.3,0-2.6,0.5-3.5,1.5c-0.9,0.9-1.5,2.2-1.5,3.5v213.9c0,1.3,0.5,2.6,1.5,3.5c0.9,0.9,2.2,1.5,3.5,1.5h64.7c1.3,0,2.6-0.5,3.5-1.5 c0.9-0.9,1.5-2.2,1.5-3.5v-69.6h69.7c1.3,0,2.6-0.5,3.5-1.5c0.9-0.9,1.5-2.2,1.5-3.5V102.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkx);
export default __webpack_public_path__ + "static/media/okx.25112db1fe060a59a6d6f1bc346ebf9e.svg";
export { ForwardRef as ReactComponent };